import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6a987b40"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "model",
  ref: "threeRef"
}
const _hoisted_2 = ["width", "height"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("canvas", {
      ref: "canvasRef",
      width: _ctx.width,
      height: _ctx.height
    }, null, 8, _hoisted_2)
  ], 512))
}